import { createContext, useContext } from "react"

export interface SliceSelection {
  /**
   * The keys of the slices that are currently selected.
   */
  ids: string[]

  isSelected: (id: string) => boolean

  /**
   * Update the current selection.
   * @param args.requestedFrom Which Area of the app is requesting the change.
   * This is useful to know how/whether to scroll to the matching selection in the other area.
   */
  update: (args: SliceSelectionUpdateArgs) => void
}

export interface SliceSelectionUpdateArgs {
  id: string
  requestedFrom: "all" | SliceSelectionArea
  shiftKey?: boolean
  metaKey?: boolean
  ids?: string[]
}

export type SliceSelectionArea = "sliceTable" | "sliceFieldSet"

export function getSliceSelectionDOMId(area: SliceSelectionArea, id: string) {
  return `${area}___${id}`
}

export const SliceSelectionContext = createContext<SliceSelection>({
  ids: [],
  isSelected: () => false,
  update: () => {},
})

export function useSliceSelection() {
  return useContext(SliceSelectionContext)
}
